<div class="bg-error-light flex gap-x-4 p-5">
  <img [ngSrc]="'@shared-core/icons/error_icon.svg'" [width]="42" [height]="42" alt="" />
  <div class="flex w-full flex-col justify-between gap-y-1">
    <span class="font-bold">Fehler</span>
    <span>{{ message() }}</span>
  </div>
  <div>
    <button class="pointer-events-auto h-fit cursor-pointer py-1" (click)="closeToast.emit()">
      <shared-core-material-icon [name]="'close'" />
    </button>
  </div>
</div>
